import React from 'react'

export const stopLinterErrors = 0

export const renderTextWithNewlines = (text: string): React.ReactNode[] => {
  const lines = text.split('\n')
  const result: React.ReactNode[] = []

  for (let i = 0; i < lines.length; i += 1) {
    result.push(lines[i])
    if (i < lines.length - 1) {
      result.push(<br key={`br-${i}`} />)
    }
  }

  return result
}
